import { ValidationsMap } from '../typings';

export const syncValidationsMapper: ValidationsMap = {};
